import debounce from "./debounce";
import * as is from "./is"

export {
  debounce,
  is,
}
